import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'assets-fixed';
import  basicApi from '../../../../api/AccountManagementApi/accountManagement'
import api from './../../../../api/assest-management/base-management/index'
import assetApi from '../../../../api/assest-management/assets-register/index'
import DataUtils from '../../../../libs/utils/DataUtils'
export const state = {
    status: 'list',             //  list add  edit  view 列表页  新增页 编辑  查看
    unitList:[],
    projectList:[],
    departMentList:[],
    supplierlist:[],
    personnelList:[],
    subClassList:[],
    addressList:[],
    addressTree:[],
    detailForm:{},
    assetFlag:'',// 0 1 2 

    valueList:[
        {id:1,name:"原值"},
        {id:2,name:"暂估值"},
        {id:3,name:"公允价值"}
    ],
    statusList:[
        {id:0,name:"未报账 "},
        {id:1,name:"报账中"},
        {id:2,name:"报账成功"},
        {id:3,name:"已驳回"},

    ],
    depreciationList:[
        {id:0,name:"不折旧 "},
        {id:1,name:"平均年限法"},
        {id:2,name:"双倍余额递减法"},
     

    ],
  
    useList:[
        {id:1,name:"出租或出借 "},
        {id:2,name:"自用"},
        {id:3,name:"闲置"},
        {id:4,name:"借用"},
        {id:5,name:"维修中 "},
        {id:6,name:"停用"},
        {id:7,name:"报废"},
        {id:8,name:"已处置"},
        {id:9,name:"待处置"},
    ],
    assetsDepHistory:[],
    assetOptionsHistory:[]

   
   
}
export const mutations = {
    setUnitList(state,data){
        state.unitList = data
    },
    setProjectList(state,data){
        state.projectList = data
    },
    setDepartMentList(state,data){
        state.departMentList = data
    },
    setSupplierlist(state,data){
        state.supplierlist = data
    },
    setPersonnelList(state,data){
        state.personnelList = data
    },
    setSubClassList(state,data){
        state.subClassList = data
       
    },
    setAddressList(state,data){
        state.addressList = data
    },
    setAddressTree(state,data){
        state.addressTree = data
    },
    setStatus(state,data){
        state.status  =data
    },
    setDetailForm(state,data){
        state.detailForm  = {...data}
    },
    setAssetFlag(state,data){
        state.assetFlag  =data
    },
     
  setAssetsDepHistory(state, data){
    state.assetsDepHistory = data;
  },
  //设置操作历史信息
  setAssetOptionsHistory(state, data){
    state.assetOptionsHistory = data;
  },
   
    
}
export const actions = {
    async handleMenuGet({ state, commit }){
       let menuListReq = [];
       menuListReq.push(api.unitAll());
       menuListReq.push(basicApi.allDepartment());
       menuListReq.push(basicApi.allPersonnel());
       menuListReq.push(basicApi.allProject());
       menuListReq.push(basicApi.allSupplier());
      
       menuListReq.push();
       let menuListRes = await Promise.all(menuListReq);
       if(menuListRes.length>0){
          
        commit('setUnitList',menuListRes[0].data)
        commit('setDepartMentList',menuListRes[1].data)
        commit('setPersonnelList',menuListRes[2].data)
        commit('setProjectList',menuListRes[3].data)
        commit('setSupplierlist',menuListRes[4].data)

       
       }
    },
      //获取折旧历史信息
  async getAssetsHistory({commit, state, dispatch},param){
    let params = {
      assetId: param.id,
    };
    let res = await assetApi.assetdepreciationhistoryList(params);
    if(res.code == 0){
        
      commit("setAssetsDepHistory", res.data);
    }
  },

  //获取操作历史记录
  async getHistoryList({commit, state, dispatch}, param){
    let res = await assetApi.getassetoperatelogList(param);
    if(res.code == 0){
      commit("setAssetOptionsHistory", res.data || []);
    }
  },
}
export const getters = {
    title(state) {
        return state.assetFlag == 0?'固定资产':state.assetFlag == 1?'无形资产':state.assetFlag == 2?'生物资产':""
    },
   

}



// WEBPACK FOOTER //
// ./src/store/modules/assest-management/assets-register/index.js